import { RouteProps } from 'react-router-dom';
import { SubscriptionFeatureFlag } from '@mm/state/controllers/FeatureFlags';
import { landmineNames } from '@mm/constants/landmine-names';
import ZapierPanel from '../../../zapier/panels/ZapierPanel/ZapierPanel';
import * as routes from '../../../../../common/constants/routes';
import { NativeIntegrations } from './NativeIntegrations/NativeIntegrations';
import { EmailIntegration } from './NativeIntegrations/components/EmailIntegrations/EmailIntegration';
import ConnectionsTableGrid from '../../../connections/components/ConnectionsTableGrid/ConnectionsTableGrid';
import { SlackIntegrations } from './NativeIntegrations/components/SlackIntegrations/SlackIntegrations';
import { ContactSuppression } from './NativeIntegrations/components/ContactSuppressions/ContactSuppression';

export type PageSettingDefinition = {
  id: string;
  path: (chatbotId: number) => string;
  name: string;
  component: RouteProps['component'];
  requiredFeature?: SubscriptionFeatureFlag;
  landmineName: string;
  helpDoc?: string;
};

export const INTEGRATIONS_SECTIONS: PageSettingDefinition[] = [
  {
    id: 'email',
    name: 'Email',
    path: chatbotId => routes.INTEGRATIONS_EMAIL(chatbotId),
    component: EmailIntegration,
    requiredFeature: 'nativeIntegrations',
    landmineName: landmineNames.INTEGRATIONS_EMAIL,
    helpDoc:
      'https://mobilemonkey.com/help/l/en/article/z3rhglizny-e-mail-integration',
  },
  {
    id: 'native_integrations',
    name: 'CRM',
    path: chatbotId => routes.INTEGRATIONS_NATIVE_INTEGRATIONS(chatbotId),
    component: NativeIntegrations,
    requiredFeature: 'nativeIntegrations',
    landmineName: landmineNames.INTEGRATIONS_NATIVE_INTEGRATIONS,
    helpDoc:
      'https://mobilemonkey.com/help/l/en/article/eiftlr4g98-google-sheet-integration',
  },
  {
    id: 'notifications',
    name: 'Notifications',
    path: chatbotId => routes.INTEGRATIONS_NOTIFICATIONS(chatbotId),
    component: SlackIntegrations,
    requiredFeature: 'nativeIntegrations',
    landmineName: landmineNames.INTEGRATIONS_NOTIFICATIONS,
    helpDoc:
      'https://mobilemonkey.com/help/l/en/article/7a98jv7u4i-integrations',
  },
  {
    id: 'json-webhooks',
    name: 'JSON Webhooks',
    path: chatbotId => routes.INTEGRATIONS_JSON_WEBHOOKS(chatbotId),
    component: ConnectionsTableGrid,
    requiredFeature: 'jsonWebhook',
    landmineName: landmineNames.INTEGRATIONS_JSON_WEBHOOKS,
    helpDoc:
      'https://mobilemonkey.com/help/l/en/article/k9bvihr044-using-the-get-connection',
  },
  {
    id: 'zapier',
    name: 'Zapier',
    path: chatbotId => routes.INTEGRATIONS_ZAPIER(chatbotId),
    component: ZapierPanel,
    requiredFeature: 'zapier',
    landmineName: landmineNames.INTEGRATIONS_ZAPIER,
    helpDoc:
      'https://mobilemonkey.com/help/l/en/article/7a98jv7u4i-integrations',
  },
  {
    id: 'contact-suppression',
    name: 'Contact Suppression',
    path: chatbotId => routes.INTEGRATIONS_CONTACT_SUPPRESSION(chatbotId),
    component: ContactSuppression,
    landmineName: landmineNames.INTEGRATIONS_CONTACT_SUPPRESSION,
    requiredFeature: undefined,
    helpDoc: '',
  },
];
